import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef } from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import * as Rollbar from 'rollbar';
import { Router } from '@angular/router';
import { RollbarService } from '../rollbar';
@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent implements OnInit {
  AlertMessage = "";
  AlertDiv;
  constructor(private router: Router, mediaObserver: MediaObserver,
    public thisDialogRef: MatDialogRef<AlertMessageComponent>,
    @Inject(RollbarService) private rollbar: Rollbar, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.AlertMessage = data.AlertMessage;
    setTimeout(() => { 
      if(data.AlertMessage == "Authentication Failed"){
        let element = document.getElementById("divAlertMessage_Data");
        element.innerHTML = data.AlertMessage;
      }
    },100);
  }

  ngOnInit() {
  }
  // close alert Notification Dialog
  public onCloseAlertMessage = () => {
    let element = document.getElementById("divAlertMessage_Data");
    if(element.innerHTML == "Authentication Failed"){
      this.thisDialogRef.close('Ok');
      localStorage.clear();  
      this.router.navigate(['/login']);
      return false;
    }
    else{
      this.thisDialogRef.close('Ok');
    }
  }
}

